const GAP_PX = 12

export const ringSpacingPlugin = {
    id: "ringSpacing",
    afterUpdate(chart) {
        let visibleIndex = 0
        chart.data.datasets.forEach((_, i) => {
            const meta = chart.getDatasetMeta(i)
            if (meta.hidden) return
            const inset = visibleIndex * GAP_PX
            meta.data.forEach((el) => {
                el.outerRadius -= inset
                el.innerRadius -= inset
            })
            visibleIndex++
        })
    },
}
